import { Box, Link, Typography } from '@mui/material'
import { color } from 'config/color'
import BackgroundImage from 'assets/icons/Waves.svg'
import Logo from 'assets/icons/ClientLogo.svg'

const SystemUnderMaintenance: React.FC = () => {
  return (
    <Box bgcolor={color.background[50]} width="100%" height="100vh" sx={{
      backgroundImage: `url(${BackgroundImage})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'bottom',
      backgroundSize: 'contain'
    }}>
      <Box display="flex" flexDirection="column" gap="20px" alignItems="center" pt={25} >
        <Box component="img" src={Logo} height={70} alt="Logo" />
        <Typography fontSize="24px" fontWeight="600" color={color.black}>
          Coming Soon
        </Typography>
        <Box width="50%">
          <Typography fontSize="18x" color={color.grey[900]} align="center">
            Welcome to your new Del-Co Water Customer Portal. <br /> This site is currently under construction and will be live on February 25, 2025. <br />
            <br />No payments can be processed at this time. As a result, no penalty fees are being added. <br />
            When the new portal goes live, your account number will be changing. <br /> It can be found on your next bill or by contacting customer service. <br /><br />
            For more information about the new portal, please visit <Link href="https://delcowater.org/billingsystem/" target="_blank">our website</Link>.
          </Typography>
        </Box>
      </Box>
    </Box>

  )
}


// SystemUnderMaintenance.tsx
// const SystemUnderMaintenance: React.FC = () => {
//   return (
//     <Box bgcolor={color.background[50]} width="100%" height="100vh" sx={{
//       backgroundImage: `url(${BackgroundImage})`,
//       backgroundRepeat: 'no-repeat',
//       backgroundPosition: 'bottom',
//       backgroundSize: 'contain'
//     }}>
//       <Box display="flex" flexDirection="column" gap="20px" alignItems="center" pt={25} >
//         <SvgImage name="NoDataIcon" width={100} height={100} />
//         <Text fontSize="24px" fontWeight="600" color={color.black}>
//           System Under Maintenance
//         </Text>
//         <Box width="50%">
//           <Text fontSize="18x" color={color.grey[900]} align="center">
//             The Delco Portal is currently down for maintenance. We expect
//             to be back in working the next business day. Thank you for your
//             patience.
//           </Text>
//         </Box>
//         <Box display="flex" flexDirection="column" gap="5px" >
//           <Typography
//             align="center"
//             textTransform="uppercase"
//             color={color.grey[900]}
//             fontSize="12px"
//           >
//             Reach us at
//           </Typography>
//           <Box display="flex" gap="5px" justifyContent="center" alignItems="center">
//             <Typography color={color.black} fontWeight="600" fontSize={16}>
//               Customer Service:
//             </Typography>
//             <Typography color={color.background[900]} fontSize={16}>{CONTACT_PHONE}</Typography>
//           </Box>
//           {/* <Box display="flex" gap="5px" justifyContent="center">
//             <Typography color={color.black} fontWeight="600" fontSize={16}>
//               Email:
//             </Typography>
//             <Typography color={color.background[900]} fontSize={16}>csr@esc-testing.com</Typography>
//           </Box> */}
//         </Box>
//       </Box>
//     </Box>

//   )
// }


export default SystemUnderMaintenance
